function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconsFilterFitnessPlayerInstructor = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-da232395-775c-40a6-8ea2-5681222e23a9",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 8.34,
    r: 7.34,
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.66px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.03,26.76s11.54,5.02,25.86,0c0,0,.75-9.18-7.26-10.33,0,0-.54,1.04-2.61,1.82-1.89.71-3.99.72-5.92.12-1.2-.37-2.5-.98-3.29-1.94,0,0-6.61,1.86-6.79,10.33Z",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.66px"
    }
  }));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconsFilterFitnessPlayerInstructor, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icons_Filter_FitnessPlayer_Instructor.084c7220.svg";
export { ForwardRef as ReactComponent };